'use client';

import { FC, useEffect, useContext, useState } from 'react';
import { Dialog, Flex, Button, ButtonGroup, Input } from '@/_components';
import { EditDescriptionDialogProps } from './EditDescriptionDialog.types';
import { updateDescription } from '@/_api/client-documents';
import { DocumentsContext } from '@/_contexts/DocumentsProvider';
import { ToastContext } from '@/_contexts/ToastProvider';
import { UserContext } from '@/_contexts/UserProvider';

export const EditDescriptionDialog: FC<EditDescriptionDialogProps> = ({
  item,
  onClose,
}) => {
  const { addToast } = useContext(ToastContext);
  const { token } = useContext(UserContext);
  const { reloadFiles, companyId } = useContext(DocumentsContext);

  const [isLoading, setLoading] = useState<boolean>(false);
  const [description, setDescription] = useState<string>('');

  useEffect(() => {
    // Initialize with either the description or an empty string
    setDescription(item?.description || '');
  }, [item?.description]);

  const onDescriptionChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setDescription(event.target.value);

  const onUpdateDescription = async () => {
    setLoading(true);

    try {
      await updateDescription({
        companyId: companyId!,
        extractedDocumentId: item?.extracted_document_id!,
        description,
        token,
      });
    } catch (error) {
      addToast('error', null, { error });
    } finally {
      reloadFiles();
      setDescription('');
      onClose();
      setLoading(false);
    }
  };

  return (
    <Dialog isOpen={!!item} onClose={onClose} title="Edit Description">
      <Dialog.Content>
        <Flex isColumn={true} gap={6}>
          <Input
            value={description}
            label="Description"
            autoFocus={true}
            autoComplete="new-password"
            onChange={onDescriptionChange}
            placeholder="Describe this document..."
          />
          <ButtonGroup align="right">
            <Button value="Cancel" intent="secondary" onClick={onClose} />
            <Button
              value="Update"
              intent="primary"
              isLoading={isLoading}
              onClick={onUpdateDescription}
              isDisabled={isLoading}
            />
          </ButtonGroup>
        </Flex>
      </Dialog.Content>
    </Dialog>
  );
};
